export const getApiBaseUrl = (serviceType = 'core-api') => {
  const nodeEnv = process.env.NODE_ENV;
  const appEnvironment = process.env.REACT_APP_ENVIRONMENT || 'local';
  const isLocal =
    (nodeEnv === 'development' || appEnvironment === 'local') &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocal) {
    const localPorts = {
      'core-api': '4000',
    };
    const port = localPorts[serviceType] || '4000';
    return `http://localhost:${port}`;
  }

  const explicitBase = process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.trim();
  if (explicitBase) {
    return explicitBase;
  }

  return 'https://api.aariyatalk.com';
};

/**
 * @deprecated Voice/TTS WebSocket services are decommissioned. LiveKit Cloud handles all voice.
 * Retained for backward compatibility — always returns null in production.
 */
export const getWebSocketUrl = () => null;

export const API_BASE = getApiBaseUrl('core-api');

export const createApiUrl = (endpoint, serviceType = 'core-api') => {
  const base = getApiBaseUrl(serviceType);
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return base ? `${base}${cleanEndpoint}` : cleanEndpoint;
};

export const isLocalDevelopment = () => {
  const nodeEnv = process.env.NODE_ENV;
  const appEnvironment = process.env.REACT_APP_ENVIRONMENT || 'local';
  return (
    (nodeEnv === 'development' || appEnvironment === 'local') &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  );
};

export const isProduction = () => {
  return process.env.NODE_ENV === 'production' && !isLocalDevelopment();
};

export default {
  API_BASE,
  createApiUrl,
  getApiBaseUrl,
  getWebSocketUrl,
  isLocalDevelopment,
  isProduction,
};
